interface PricingSectionProps {
    onOpenDemo: () => void;
}

const PricingSection = ({ onOpenDemo }: PricingSectionProps) => {
    return (
        <section id="pricing" className="py-20 bg-white">
            <div className="container mx-auto px-4">
                <div className="text-center mb-14">
                    <span className="text-blue-600 font-semibold text-sm uppercase tracking-widest">Transparent Pricing</span>
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-2">Plans starting from £75/month</h2>
                    <p className="text-gray-500 mt-3 max-w-xl mx-auto">
                        No hidden fees. Cancel anytime. All plans include the mobile app.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 gap-8 max-w-3xl mx-auto">

                    {/* Standard */}
                    <div className="bg-white border-2 border-blue-600 rounded-2xl p-8 flex flex-col shadow-xl">
                        <div className="mb-6">
                            <h3 className="text-lg font-bold text-gray-800">Standard</h3>
                            <p className="text-gray-500 text-sm mt-1">For single-site businesses</p>
                            <div className="mt-4">
                                <span className="text-4xl font-extrabold text-blue-700">From £75</span>
                                <span className="text-gray-400 text-sm">/month</span>
                            </div>
                        </div>
                        <ul className="space-y-3 text-sm text-gray-600 mb-8 flex-1">
                            <li className="flex gap-2"><i className="fas fa-check text-green-500 mt-0.5"></i> Unlimited scanning sessions</li>
                            <li className="flex gap-2"><i className="fas fa-check text-green-500 mt-0.5"></i> AI + Barcode scanning</li>
                            <li className="flex gap-2"><i className="fas fa-check text-green-500 mt-0.5"></i> PDF report generation</li>
                            <li className="flex gap-2"><i className="fas fa-check text-green-500 mt-0.5"></i> Priority email support</li>
                        </ul>
                        <button
                            onClick={onOpenDemo}
                            className="w-full cta-amber text-white py-3 rounded-xl font-bold shadow hover:shadow-md transition"
                        >
                            Book a Demo
                        </button>
                    </div>

                    {/* Custom */}
                    <div className="bg-gray-50 border border-gray-200 rounded-2xl p-8 flex flex-col">
                        <div className="mb-6">
                            <h3 className="text-lg font-bold text-gray-800">Custom</h3>
                            <p className="text-gray-500 text-sm mt-1">For businesses with 2 or more sites</p>
                            <div className="mt-4">
                                <span className="text-4xl font-extrabold text-gray-800">Custom</span>
                            </div>
                        </div>
                        <ul className="space-y-3 text-sm text-gray-600 mb-8 flex-1">
                            <li className="flex gap-2"><i className="fas fa-check text-green-500 mt-0.5"></i> Everything in Standard</li>
                            <li className="flex gap-2"><i className="fas fa-check text-green-500 mt-0.5"></i> Dedicated account support</li>
                            <li className="flex gap-2"><i className="fas fa-check text-green-500 mt-0.5"></i> Custom onboarding</li>
                        </ul>
                        <a
                            href="#contact"
                            className="w-full border-2 border-blue-600 text-blue-600 py-3 rounded-xl font-semibold hover:bg-blue-50 transition text-center"
                        >
                            Contact Us
                        </a>
                    </div>

                </div>

                <p className="text-center text-gray-400 text-xs mt-8">
                    <i className="fas fa-lock mr-1"></i> Prices are indicative. Exact pricing confirmed during your demo call.
                </p>
            </div>
        </section>
    );
};

export default PricingSection;
